<section id="nr_slider" class="row">
    <div class="mainSliderContainer">
        <div class="mainSlider">                             
            <ul>
                <!-- SLIDE  -->
                <li data-transition="boxslide" data-slotamount="7">
                    <img src="../../../assets/images/slider/slide1.png" alt="slidebg1" data-bgfit="cover" data-bgposition="left top"
                        data-bgrepeat="no-repeat">
                    <div class="caption sfr str" data-x="-100" data-y="135" data-speed="700" data-start="1700"
                        data-easing="easeOutBack">
                        <h1>
                            {{'slogan' | translate}}
                        </h1>
                    </div>

                    <div class="caption sfl stl" data-x="-100" data-y="190" data-speed="500" data-start="1900"
                        data-easing="easeOutBack">
                        <h1> <span>{{'supslogan' | translate}}</span> {{'supslogan2' | translate}} <span> {{'supslogan3' | translate}}</span> </h1>
                    </div>
                    <!--<div class="caption sfr str"
                        data-x="center"
                        data-y="140"
                        data-speed="700"
                        data-start="1700"
                        data-easing="easeOutBack">
                        <h2><strong> multi-disciplined</strong> engineering consulting firm</h2>
                    </div>
                    <div class="caption sfl stl"
                        data-x="center"
                        data-y="225"
                        data-speed="500"
                        data-start="1900"
                        data-easing="easeOutBack">
                        <h3>{{'slogan' | translate}}  more than  <strong> 30 years</strong>  </h3>
                    </div>-->

                    <div class="caption sfb stb" data-x="center" data-y="400" data-hoffset="0" data-speed="500"
                        data-start="1900" data-easing="easeOutBack">
                        <div class="ico_box" routerLink="/facility-management">
                            <a>
                                <!--<img src="images/faciliticon.png" style="margin-bottom: 5px;" class="fa fa-3x" />-->
                                <i class="fa icofont-tools fa-3x"></i>
                                <br />
                                <strong>
                                    {{'FacilityManagement' | translate}}
                                </strong>
                            </a>
                        </div>
                    </div>
                    <div class="caption skewfromright skewtoright" data-x="center" data-y="400" data-hoffset="176"
                        data-speed="500" data-start="1900" data-easing="easeOutBack">
                        <div class="ico_box"  routerLink="/arbitration">
                            <a>
                                <i class="fa fa-gavel fa-3x"></i>
                                <br />
                                <strong>{{'Arbitration' | translate}}</strong>
                            </a>
                        </div>
                    </div>
                    <div class="caption skewfromleft skewtoleft" data-x="center" data-y="400" data-hoffset="-176"
                        data-speed="500" data-start="1900" data-easing="easeOutBack">
                        <div class="ico_box" routerLink="/project-management">
                            <a>
                                <i class="icofont-chart-histogram fa-3x"></i>
                                <br />
                                <strong>
                                    {{'ProjectManagement' | translate}}
                                    <br style="line-height:20px" />
                                    {{'PMO2' | translate}}
                                </strong>
                            </a>
                        </div>

                    </div>
                    <div class="caption sfb stb" data-x="-120" data-y="460" data-hoffset="0" data-speed="500"
                        data-start="1900" data-easing="easeOutBack">
                        <a type="button" routerLink="/consultation" class="btn btn-default">{{'Getconsultation' | translate}}</a>
                    </div>

                    <!--<div class="caption sfb stb" data-x="-120" data-y="460" data-hoffset="0" data-speed="500"
                        data-start="1900" data-easing="easeOutBack">
                        <a type="button" href="RequestPrice.html" class="btn btn-default">Get a Price</a>
                    </div>-->

                </li>
                <!-- SLIDE 2 -->
                <li data-transition="boxslide" data-slotamount="7">
                    <img src="../../../assets/images/slider/slide4.png" style="opacity: 0.5!important;" alt="slidebg1"
                        data-bgfit="cover" data-bgposition="left top" data-bgrepeat="no-repeat">
                    <div class="caption sfr str" data-x="-100" data-y="135" data-speed="700" data-start="1700"
                        data-easing="easeOutBack">
                        <h1>
                            {{'slogan' | translate}}
                        </h1>
                    </div>
                    <div class="caption sfl stl" data-x="-100" data-y="190" data-speed="500" data-start="1900"
                        data-easing="easeOutBack">
                        <h1> <span>{{'supslogan' | translate}}</span> {{'supslogan2' | translate}} <span> {{'supslogan3' | translate}}</span> </h1>
                    </div>
                    <!--<div class="caption sfl stl"
                        data-x="-100"
                        data-y="190"
                        data-speed="500"
                        data-start="1900"
                        data-easing="easeOutBack">
                        <h4> </h4>
                    </div>-->
                    <div class="caption sfb stb" data-x="center" data-y="400" data-hoffset="0" data-speed="500"
                        data-start="1900" data-easing="easeOutBack">
                        <div class="ico_box" routerLink="/facility-management">
                            <a>
                                <!--<img src="images/faciliticon.png" style="margin-bottom: 5px;" class="fa fa-3x" />-->
                                <i class="fa icofont-tools fa-3x"></i>
                                <br />
                                <strong>
                                    {{'FacilityManagement' | translate}}
                                </strong>
                            </a>
                        </div>
                    </div>
                    <div class="caption skewfromright skewtoright" data-x="center" data-y="400" data-hoffset="176"
                        data-speed="500" data-start="1900" data-easing="easeOutBack">
                        <div class="ico_box" routerLink="/arbitration">
                            <a>
                                <i class="fa fa-gavel fa-3x"></i>
                                <br />
                                <strong>{{'Arbitration' | translate}}</strong>
                            </a>
                        </div>
                    </div>
                    <div class="caption skewfromleft skewtoleft" data-x="center" data-y="400" data-hoffset="-176"
                        data-speed="500" data-start="1900" data-easing="easeOutBack">
                        <div class="ico_box" routerLink="/project-management">
                            <a>
                                <i class="icofont-chart-histogram fa-3x"></i>
                                <br />
                                <strong>
                                    {{'ProjectManagement' | translate}}
                                    <br style="line-height:20px" />
                                    {{'PMO2' | translate}}
                                </strong>
                            </a>
                        </div>

                    </div>

                    <div class="caption sfb stb" data-x="-120" data-y="460" data-hoffset="0" data-speed="500"
                        data-start="1900" data-easing="easeOutBack">
                        <a type="button" routerLink="/consultation" class="btn btn-default">{{'Getconsultation' | translate}}</a>
                    </div>
                    <!--
                    <div class="caption sfb stb" data-x="-120" data-y="460" data-hoffset="0" data-speed="500"
                        data-start="1900" data-easing="easeOutBack">
                        <a type="button" href="RequestPrice.html" class="btn btn-default">Get a Price</a>
                    </div>
                    -->
                    <!--<div class="caption skewfromright skewtoright"
                    data-x="right"
                    data-y="130"
                    data-hoffset="176"
                    data-speed="500"
                    data-start="1900"
                    data-easing="easeOutBack">
                    <div class="tools"><img src="images/slider/construction_tools2.png" style="opacity:0.6" alt="brifcase"></div>
                </div>-->
                </li>
                <!-- SLIDE 3 -->
                <li data-transition="boxslide" data-slotamount="7">
                    <img src="../../../assets/images/slider/slide2.png" alt="slidebg1" data-bgfit="cover" data-bgposition="left top"
                        data-bgrepeat="no-repeat">
                    <div class="caption sfr str" data-x="-100" data-y="135" data-speed="700" data-start="1700"
                        data-easing="easeOutBack">
                        <h1>
                            {{'slogan' | translate}}
                        </h1>
                    </div>
                    <div class="caption sfl stl" data-x="-100" data-y="190" data-speed="500" data-start="1900"
                        data-easing="easeOutBack">
                        <h1> <span>{{'supslogan' | translate}}</span> {{'supslogan2' | translate}} <span> {{'supslogan3' | translate}}</span> </h1>
                    </div>
                    <!--<div class="caption sfr str"
                        data-x="-100"
                        data-y="135"
                        data-speed="700"
                        data-start="1700"
                        data-easing="easeOutBack">

                        <h3><strong>Project Managment</strong> </h3>
                    </div>
                    <div class="caption sfl stl"
                        data-x="-100"
                        data-y="190"
                        data-speed="500"
                        data-start="1900"
                        data-easing="easeOutBack">
                        <h4>{{'slogan' | translate}}  more than  <strong> 30 years</strong>  </h4>
                    </div>-->
                    <!--<div class="caption skewfromleft skewtoleft"
                        data-x="-100"
                        data-y="265"
                        data-hoffset="-176"
                        data-speed="500"
                        data-start="1900"
                        data-easing="easeOutBack">
                        <p>This is Photoshop's version of Lorem Ipsum. Proin gravi-<br>da nibh vel velit auctor aliquet. Aenean solicitudin. lorem <br>quis bibendum auctor, nisi elit consequant.</p>
                    </div>-->
                    <div class="caption sfb stb" data-x="-120" data-y="460" data-hoffset="0" data-speed="500"
                        data-start="1900" data-easing="easeOutBack">
                        <a type="button" routerLink="/consultation" class="btn btn-default">{{'Getconsultation' | translate}}</a>
                    </div>
                    <!--
                    <div class="caption sfb stb" data-x="-120" data-y="460" data-hoffset="0" data-speed="500"
                        data-start="1900" data-easing="easeOutBack">
                        <a type="button" href="RequestPrice.html" class="btn btn-default">Get a Price</a>
                    </div>
                    -->
                    <div class="caption sfb stb" data-x="center" data-y="400" data-hoffset="0" data-speed="500"
                        data-start="1900" data-easing="easeOutBack">
                        <div class="ico_box" routerLink="/facility-management">
                            <a>
                                <!--<img src="images/faciliticon.png" style="margin-bottom: 5px;" class="fa fa-3x" />-->
                                <i class="fa icofont-tools fa-3x"></i>
                                <br />
                                <strong>
                                    {{'FacilityManagement' | translate}}
                                </strong>
                            </a>
                        </div>
                    </div>
                    <div class="caption skewfromright skewtoright" data-x="center" data-y="400" data-hoffset="176"
                        data-speed="500" data-start="1900" data-easing="easeOutBack">
                        <div class="ico_box" routerLink="/arbitration">
                            <a>
                                <i class="fa fa-gavel fa-3x"></i>
                                <br />
                                <strong>{{'Arbitration' | translate}}</strong>
                            </a>
                        </div>
                    </div>
                    <div class="caption skewfromleft skewtoleft" data-x="center" data-y="400" data-hoffset="-176"
                        data-speed="500" data-start="1900" data-easing="easeOutBack">
                        <div class="ico_box" routerLink="/project-management">
                            <a>
                                <i class="icofont-chart-histogram fa-3x"></i>
                                <br />
                                <strong>
                                    {{'ProjectManagement' | translate}}
                                    <br style="line-height:20px" />
                                    {{'PMO2' | translate}}
                                </strong>
                            </a>
                        </div>

                    </div>
                    <!--<div class="caption skewfromright skewtoright"
                    data-x="right"
                    data-y="130"
                    data-hoffset="176"
                    data-speed="500"
                    data-start="1900"
                    data-easing="easeOutBack">
                    <div class="tools"><img src="images/slider/construction_tools.png" alt="brifcase"></div>
                </div>-->
                </li>
                <!-- SLIDE 4 -->
                <li data-transition="boxslide" data-slotamount="7">
                    <img src="../../../assets/images/slider/slide3.png" alt="slidebg1" data-bgfit="cover" data-bgposition="left top"
                        data-bgrepeat="no-repeat">
                    <div class="caption sfr str" data-x="-100" data-y="135" data-speed="700" data-start="1700"
                        data-easing="easeOutBack">
                        <h1>
                            {{'slogan' | translate}}
                        </h1>
                    </div>
                    <div class="caption sfl stl" data-x="-100" data-y="190" data-speed="500" data-start="1900"
                        data-easing="easeOutBack">
                        <h1> <span>{{'supslogan' | translate}}</span> {{'supslogan2' | translate}} <span> {{'supslogan3' | translate}}</span> </h1>
                    </div>
                    <!--<div class="caption sfr str"
                        data-x="-100"
                        data-y="135"
                        data-speed="700"
                        data-start="1700"
                        data-easing="easeOutBack">
                        <h3>
                            <strong>
                                {{'FacilityManagement' | translate}}
                            </strong>
                        </h3>
                    </div>-->
                    <!--<div class="caption sfl stl"
                        data-x="-100"
                        data-y="190"
                        data-speed="500"
                        data-start="1900"
                        data-easing="easeOutBack">
                        <h4>{{'slogan' | translate}}  {{'supslogan' | translate}}  <strong> 30 years</strong> </h4>
                    </div>-->
                    <!--<div class="caption skewfromleft skewtoleft"
                        data-x="-100"
                        data-y="265"
                        data-hoffset="-176"
                        data-speed="500"
                        data-start="1900"
                        data-easing="easeOutBack">
                        <p>
                            we concerned with  design, supervision, achievement
                            <br />and contract management as well.
                        </p>
                    </div>-->
                    <div class="caption sfb stb" data-x="-120" data-y="460" data-hoffset="0" data-speed="500"
                        data-start="1900" data-easing="easeOutBack">
                        <a type="button" routerLink="/consultation" class="btn btn-default">{{'Getconsultation' | translate}}</a>
                    </div>
                    <!--
                    <div class="caption sfb stb" data-x="-120" data-y="460" data-hoffset="0" data-speed="500"
                        data-start="1900" data-easing="easeOutBack">
                        <a type="button" href="RequestPrice.html" class="btn btn-default">Get a Price</a>
                    </div>
                    -->
                    <!--<div class="caption skewfromright skewtoright"
                        data-x="right"
                        data-y="0"
                        data-hoffset="176"
                        data-speed="500"
                        data-start="1900"
                        data-easing="easeOutBack">
                        <div class="sketch"><img src="images/slider/construction_tools3.png" alt="brifcase"></div>
                    </div>-->
                    <div class="caption sfb stb" data-x="center" data-y="400" data-hoffset="0" data-speed="500"
                        data-start="1900" data-easing="easeOutBack">
                        <div class="ico_box" routerLink="/facility-management">
                            <a>
                                <i class="fa icofont-tools fa-3x"></i>
                                <br />
                                <strong>
                                    {{'FacilityManagement' | translate}}
                                </strong>
                            </a>
                        </div>
                    </div>
                    <div class="caption skewfromright skewtoright" data-x="center" data-y="400" data-hoffset="176"
                        data-speed="500" data-start="1900" data-easing="easeOutBack">
                        <div class="ico_box" routerLink="/arbitration">
                            <a>
                                <i class="fa fa-gavel fa-3x"></i>
                                <br />
                                <strong>{{'Arbitration' | translate}}</strong>
                            </a>
                        </div>
                    </div>
                    <div class="caption skewfromleft skewtoleft" data-x="center" data-y="400" data-hoffset="-176"
                        data-speed="500" data-start="1900" data-easing="easeOutBack">
                        <div class="ico_box" routerLink="/project-management">
                            <a>
                                <i class="icofont-chart-histogram fa-3x"></i>
                                <br />
                                <strong>
                                    {{'ProjectManagement' | translate}}
                                    <br style="line-height:20px" />
                                    {{'PMO2' | translate}}
                                </strong>
                            </a>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
    </div>
    <div class="container sliderAfterTriangle"></div>
    <!--Triangle After Slider-->
</section>
<!--Slider-->

<section id="nr_services" class="row">
    <div class="container">
        <div class="row sectionTitles">
            <h2 class="sectionTitle">{{'OtherServices' | translate}}</h2>
            <div class="sectionSubTitle">{{'whatOffer' | translate}}</div>
        </div>
        <div class="row m0 text-center">
            <!-- <div class="row partnersSlide">
            <div class="owl-carousel partnerSlider">-->
            <div class="col-sm-2 mr-20 fleft">
                <a routerLink="/planning">
                    <div class="row m0 service">
                        <div class="row m0 innerRow">
                            <i class="fa icofont-handshake-deal"></i>
                            <div class="serviceName" >
                                {{'Planning' | translate}}
                            </div>
                        </div>
                    </div>
                </a>
            </div>
            <div class="col-sm-2 mr-20 fleft">
                <a routerLink="/designing">
                    <div class="row m0 service">
                        <div class="row m0 innerRow">
                            <i class="fa icofont-ruler-pencil fa-3x"></i>

                            <div class="serviceName" >{{'Designing' | translate}}</div>
                        </div>
                    </div>
                </a>
            </div>
            <div class="col-sm-2 mr-20 fleft">
                <a routerLink="/supervision">
                    <div class="row m0 service">
                        <div class="row m0 innerRow">
                            <i class="fa icofont-tasks"></i>
                            <div class="serviceName" >{{'SUPERVISION' | translate}}</div>
                        </div>
                    </div>
                </a>
            </div>
            <div class="col-sm-2 mr-20 fleft">
                <a routerLink="/construction-management">
                    <div class="row m0 service">
                        <div class="row m0 innerRow">

                            <i class="fa icofont-architecture fa-3x"></i>
                            <div class="serviceName" >
                                {{'ConstructionManagement' | translate}}
                            </div>
                        </div>
                    </div>
                </a>
            </div>
            <div class="col-sm-2 mr-20 fleft">
                <a routerLink="/roads">
                    <div class="row m0 service">
                        <div class="row m0 innerRow fac">

                            <i class="fa icofont-road fa-3x" style="font-size: 4em;"></i>

                            <div class="serviceName" >
                                {{'Roads' | translate}}
                            </div>
                        </div>
                    </div>
                </a>
            </div>


            <!--</div>
            </div>-->
        </div>
        <div class="row m0 text-center">
            <!-- <div class="row partnersSlide">
            <div class="owl-carousel partnerSlider">-->


            <div class="col-sm-2 mr-20 ml-120 fleft">
                <a routerLink="/environmental-sustainability">
                    <div class="row m0 service">
                        <div class="row m0 innerRow fac">

                            <i class="fa icofont-recycle-alt fa-3x" style="font-size: 4em;"></i>

                            <div class="serviceName" >
                                {{'EnvironmentalSustainability' | translate}}
                            </div>
                        </div>
                    </div>
                </a>
            </div>
            <div class="col-sm-2 mr-20 fleft">
                <a routerLink="/vision-realization">
                    <div class="row m0 service">
                        <div class="row m0 innerRow fac">

                            <i class="fa icofont-eye-alt fa-3x" style="font-size: 4em;"></i>

                            <div class="serviceName" >
                                {{'VRO' | translate}}
                            </div>
                        </div>
                    </div>
                </a>
            </div>
            <div class="col-sm-2 mr-20 fleft">
                <a routerLink="/green-buildings">
                    <div class="row m0 service">
                        <div class="row m0 innerRow fac">

                            <i class="fa fa-home fa-3x" style="font-size: 4em;"></i>

                            <div class="serviceName" >
                                {{'GreenBuildings' | translate}}
                            </div>
                        </div>
                    </div>
                </a>
            </div>
            <div class="col-sm-2 mr-20 fleft">
                <a routerLink="/infrastructure">
                    <div class="row m0 service">
                        <div class="row m0 innerRow fac">
                            <i class="fa icofont-layers fa-3x" style="font-size: 4em;"></i>
                            <div class="serviceName">
                                {{'Infrastructure' | translate}}
                            </div>
                        </div>
                    </div>
                </a>
            </div>
            <!--</div>
            </div>-->
        </div>

    </div>
</section>
<!--Services-->

<section id="elements" class="row">
    <div class="row sectionTitles m0">
        <h2 class="sectionTitle"> {{'Partners' | translate}}</h2>
        <!--<div class="sectionSubTitle">  </div>-->
    </div>
    <div class="container">
        <div class="row">
            <div class="col-sm-12">
                <div class="row m0 leftAlignedTap">
                    <ul class="nav nav-tabs" role="tablist" id="myTab">
                        <li role="presentation" class="active">
                            <a href="#h_tab0" aria-controls="h_tab0" role="tab" data-toggle="tab">
                                <img src="../../../assets/images/partner/m.png" class="img-thumbnail" />
                            </a>
                        </li>
                        <li role="presentation">
                            <a href="#h_tab3" aria-controls="h_tab3" role="tab" data-toggle="tab">
                                <img src="../../../assets/images/partner/hill.jpg" class="img-thumbnail" />
                            </a>
                        </li>
                        <li role="presentation">
                            <a href="#h_tab1" aria-controls="h_tab1" role="tab" data-toggle="tab">
                                <img src="../../../assets/images/partner/uniti.jpg" class="img-thumbnail" />
                            </a>
                        </li>
                        <li role="presentation">
                            <a href="#h_tab2" aria-controls="h_tab2" role="tab" data-toggle="tab">
                                <img src="../../../assets/images/partner/Unisearch.jpg" class="img-thumbnail" />
                            </a>
                        </li>


                        <li role="presentation">
                            <a href="#h_tab4" aria-controls="h_tab4" role="tab" data-toggle="tab">
                                <img src="../../../assets/images/partner/RS.jpg" class="img-thumbnail" />
                            </a>
                        </li>
                        <li role="presentation">
                            <a href="#h_tab5" aria-controls="h_tab5" role="tab" data-toggle="tab">
                                <img src="../../../assets/images/partner/NAGA.jpg" class="img-thumbnail" />
                            </a>
                        </li>
                        <li role="presentation">
                            <a href="#h_tab6" aria-controls="h_tab6" role="tab" data-toggle="tab">
                                <img src="../../../assets/images/partner/Profesional.jpg" class="img-thumbnail" />
                            </a>
                        </li>
                        <li role="presentation">
                            <a href="#h_tab7" aria-controls="h_tab7" role="tab" data-toggle="tab">
                                <img src="../../../assets/images/partner/Turbak.jpg" class="img-thumbnail" />
                            </a>
                        </li>
                    </ul>
                    <div class="tab-content">
                        <div role="tabpanel" class="tab-pane active" id="h_tab0">
                            <div class="col-sm-12" style=" padding-left: 0px;">
                                <div class="col-sm-3">
                                </div>

                                <div class="col-sm-12">
                                    <strong>Global Consulting and Training Professionals (GCTP)</strong> {{'GCTP' | translate}}

                                    <br /><br />
                                </div>

                                <div class="col-sm-12">{{'GCTP2' | translate}}
                                    <br /><br />
                                </div>

                                <div class="col-sm-12">{{'GCTP3' | translate}}
                                    <br /><br />
                                </div>

                                <!-- <div class="col-sm-12">
                                    GCTP combines scientific precision, 
                                    validity and qualitative and quantitative method competences with practical and context-based approaches for an inclusive international. GCTP provides efficient, integrated support to achieve long-term and sustainable 
                                    organizational growth. We work with individuals and organizations in collaboration with the team to improve the overall corporate and specific capabilities. We leverage technology to streamline workflow processes, enable 
                                    better workforce management, and assist in management decision making. Health and Safety is a Core Value and fundamental to GCTP’s business, wherever work is performed. 
                                    <br /><br />
                                </div> -->

                            </div>

                        </div>
                        <div role="tabpanel" class="tab-pane " id="h_tab1">
                            <div class="col-sm-12" style=" padding-left: 0px;">
                                <div class="col-sm-3">
                                </div>

                                <div class="col-sm-12">
                                    <strong>UNITI Consultants Sdn. Bhd.</strong> {{'UNITI' | translate}}
                                    <br /><br />
                                </div>

                            </div>

                            <div class="col-sm-12">
                                {{'UNITI2' | translate}}
                            </div>
                        </div>
                        <div role="tabpanel" class="tab-pane " id="h_tab2">
                            <div class="col-sm-12">
                                <div class="col-sm-3">

                                </div>
                                <div class="col-sm-12" style=" padding-left: 0px;">
                                    <strong>Unisearch</strong> {{'Unisearch' | translate}}
                                    <br /><br />
                                </div>
                            </div>

                            <div class="col-sm-12">
                                {{'Unisearch2' | translate}}
                            </div>
                        </div>

                        <div role="tabpanel" class="tab-pane" id="h_tab3">
                            <div class="col-sm-12">
                                <div class="col-sm-3">
                                </div>
                                <div class="col-sm-12" style=" padding-left: 0px;">
                                    <strong>HILL</strong> {{'HILL' | translate}}
                                    <br /><br />
                                </div>
                            </div>

                            <div class="col-sm-12">
                                {{'HILL2' | translate}}

                            </div>
                            <div class="col-sm-12">
                                {{'HILL3' | translate}}
                            </div>
                        </div>

                        <div role="tabpanel" class="tab-pane " id="h_tab4">
                            <div class="col-sm-12">
                                <div class="col-sm-3">

                                </div>
                                <div class="col-sm-12" style=" padding-left: 0px;">

                                    <strong>RS Management</strong> {{'RS' | translate}}
                                    <br /><br />
                                </div>
                            </div>

                            <div class="col-sm-12">
                                {{'RS2' | translate}}

                            </div>
                        </div>

                        <div role="tabpanel" class="tab-pane " id="h_tab5">
                            <div class="col-sm-12">
                                <div class="col-sm-3">
                                </div>
                                <div class="col-sm-12" style=" padding-left: 0px;">

                                    <strong>NAGA</strong> {{'NAGA' | translate}}
                                    <br /><br />
                                </div>
                            </div>
                            <br />
                            <div class="col-sm-12">
                                {{'NAGA2' | translate}}

                            </div>
                        </div>
                        <div role="tabpanel" class="tab-pane " id="h_tab6">
                            <div class="col-sm-12">
                                <div class="col-sm-3">
                                </div>
                                <div class="col-sm-12" style=" padding-left: 0px;">
                                    <strong>Professional Engineers </strong> {{'ProfessionalEngineers' | translate}}

                                    <br /><br />
                                </div>
                            </div>
                            <br />
                            <div class="col-sm-12">
                            </div>
                        </div>

                        <div role="tabpanel" class="tab-pane " id="h_tab7">
                            <div class="col-sm-12">
                                <div class="col-sm-3">

                                </div>
                                <div class="col-sm-12" style=" padding-left: 0px;">

                                    <strong> AL Turbak office</strong> {{'Turbak' | translate}}

                                    <br /><br />
                                </div>

                            </div>
                            <br />
                            <div class="col-sm-12">
                                {{'Turbak2' | translate}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<!--Elements-->

<section id="elements" class="row">
    <div class="row sectionTitles m0">
        <h2 class="sectionTitle"> {{'Clients' | translate}}</h2>
        <!--<div class="sectionSubTitle">elements</div>-->
    </div>
    <div class="container">
        <div class="row">
            <div class="row partnersSlide">
                <div class="owl-carousel partnerSlider">
                    <div class="item"><img src="../../../assets/images/Client/client1.png" class="" alt=""></div>
                    <div class="item"><img src="../../../assets/images/Client/client2.png" class="" alt=""></div>
                    <div class="item"><img src="../../../assets/images/Client/client3.png"class="" alt=""></div>
                    <div class="item"><img src="../../../assets/images/Client/client4.png" class="" alt=""></div>
                    <div class="item"><img src="../../../assets/images/Client/client5.png" class="" alt=""></div>
                    <div class="item"><img src="../../../assets/images/Client/client6.png" class="" alt=""></div>
                    <div class="item"><img src="../../../assets/images/Client/client7.png"class="" alt=""></div>
                    <div class="item"><img src="../../../assets/images/Client/client8.png" class="" alt=""></div>
                    <div class="item"><img src="../../../assets/images/Client/client9.png" class="" alt=""></div>
                    <div class="item"><img src="../../../assets/images/Client/client10.png" class="" alt=""></div>
                    <div class="item"><img src="../../../assets/images/Client/client11.png"class="" alt=""></div>
                    <div class="item"><img src="../../../assets/images/Client/client12.png" class="" alt=""></div>
                    <div class="item"><img src="../../../assets/images/Client/client13.png" class="" alt=""></div>
                    <div class="item"><img src="../../../assets/images/Client/client14.png" class="" alt=""></div>
                    <div class="item"><img src="../../../assets/images/Client/client15.png"class="" alt=""></div>
                    <div class="item"><img src="../../../assets/images/Client/client16.png" class="" alt=""></div>
                    <div class="item"><img src="../../../assets/images/Client/client17.png" class="" alt=""></div>
                    <div class="item"><img src="../../../assets/images/Client/client18.png" class="" alt=""></div>
                    <div class="item"><img src="../../../assets/images/Client/client19.png"class="" alt=""></div>
                    <div class="item"><img src="../../../assets/images/Client/client20.png" class="" alt=""></div>
                    <div class="item"><img src="../../../assets/images/Client/client21.png" class="" alt=""></div>
                    <div class="item"><img src="../../../assets/images/Client/client22.png" class="" alt=""></div>
                    <div class="item"><img src="../../../assets/images/Client/client23.png"class="" alt=""></div>
                </div>
            </div>
        </div>
    </div>
</section>